import {type JSX } from "react";
import RegisterForm from "../components/Login/RegisterForm";
import "./LoginForm.scss"
import { useTrads } from "../contexts/trads/useTrads";
function RegisterPage (): JSX.Element{
    const {translate}=useTrads();
    return (
        <div className="login-form">
            <h4 ><a href="/"><img src="/assets/logo-tiny.png" width="50" height="50" alt="push asso" /></a> {translate('page_title_register')}</h4>
            <RegisterForm />
        </div>
    );
};

export default RegisterPage;